var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"dense":"","hide-default-footer":true},scopedSlots:_vm._u([{key:"item.created",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.created.split(" ").slice(0, 1).join("")))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }